// extracted by mini-css-extract-plugin
export default {"timedStage":"TimedStage_timedStage__zw0vv"};